import { Box, Container, Grid, Tab, Tabs, styled } from "@mui/material";

import { BORROW_OR_REPAY_TABS } from "./constants";
import Borrow from "./Borrow";
import FullWidthModal from "components/FullWidthModal";
import Repay from "./Repay";
import SwipeableViews from "react-swipeable-views";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function BorrowAndRepay({ open, onClose }) {
  const [searchParams, setSearchParams] = useSearchParams({});
  const borrow = searchParams.get("borrow");
  const repay = searchParams.get("repay");

  const borrowOrRepayTabValue = useMemo(() => {
    if (borrow) return BORROW_OR_REPAY_TABS.BORROW.index;
    else if (repay) return BORROW_OR_REPAY_TABS.REPAY.index;
  }, [borrow, repay]);

  const coinId = useMemo(() => borrow || repay, [borrow, repay]);

  const handleChange = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    const nextSlide = Object.values(BORROW_OR_REPAY_TABS).find(
      (tab) => tab.index === newValue
    );

    const prevSlide = Object.values(BORROW_OR_REPAY_TABS).find(
      (tab) => tab.index !== newValue
    );

    delete allSearchParams[prevSlide.key];

    setSearchParams({ ...allSearchParams, [nextSlide.key]: coinId });
  };

  const handleChangeIndex = (index) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    const nextSlide = Object.values(BORROW_OR_REPAY_TABS).find(
      (tab) => tab.index === index
    );

    const prevSlide = Object.values(BORROW_OR_REPAY_TABS).find(
      (tab) => tab.index !== index
    );

    delete allSearchParams[prevSlide.key];

    setSearchParams({ ...allSearchParams, [nextSlide.key]: coinId });
  };

  const pageName = useMemo(() => {
    const currentTab = Object.values(BORROW_OR_REPAY_TABS).find(
      (tab) => tab.index === borrowOrRepayTabValue
    );

    return currentTab.name;
  }, [borrowOrRepayTabValue]);

  return (
    <FullWidthModal title={pageName} open={open} onClose={onClose}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TabsStyle value={borrowOrRepayTabValue} onChange={handleChange}>
              <Tab label="Borrow" value={BORROW_OR_REPAY_TABS.BORROW.index} />
              <Tab label="Repay" value={BORROW_OR_REPAY_TABS.REPAY.index} />
            </TabsStyle>
          </Grid>

          <Grid item xs={12}>
            <SwipeableViews
              axis={"x-reverse"}
              index={borrowOrRepayTabValue}
              onChangeIndex={handleChangeIndex}
            >
              <Box
                value={borrowOrRepayTabValue}
                index={BORROW_OR_REPAY_TABS.BORROW.index}
              >
                {borrowOrRepayTabValue ===
                  BORROW_OR_REPAY_TABS.BORROW.index && (
                  <Borrow onClose={onClose} />
                )}
              </Box>

              <Box
                value={borrowOrRepayTabValue}
                index={BORROW_OR_REPAY_TABS.REPAY.index}
              >
                {borrowOrRepayTabValue === BORROW_OR_REPAY_TABS.REPAY.index && (
                  <Repay onClose={onClose} />
                )}
              </Box>
            </SwipeableViews>
          </Grid>
        </Grid>
      </Container>
    </FullWidthModal>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default BorrowAndRepay;
